/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Event_Disapproved_HintInputs */



/**
* | output |
* | --- |
* | "Review the Event content and approve if correct." |
*
* @param {Error_Nav_Event_Disapproved_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_event_disapproved_hint = /** @type {((inputs?: Error_Nav_Event_Disapproved_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Event_Disapproved_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Revoyez le contenu de l'evenement et approuvez-le si correct.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie den Veranstaltungsinhalt und genehmigen Sie ihn, falls er korrekt ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esaminare il contenuto dell'evento e approvarlo se corretto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверьте содержание мероприятия и подтвердите его, если оно соответствует требованиям.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revise el contenido del evento y apruebe si es correcto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("审核活动内容，如果正确，请批准。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの内容を確認し、正しい場合は承認します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की सामग्री की समीक्षा करें और सही होने पर उसे अनुमोदित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Analise o conteúdo do evento e aprove-o se estiver correto.")
	return /** @type {LocalizedString} */ ("Review the Event content and approve if correct.")
});